module.exports.main = `
  INSERT INTO fin.payment (
      origin, company, txn_id, txn_date,
      customer_id, account_id, amount, unapplied_amount, currency, private_note
  )
  SELECT origin
       , company
       , txn_id
       , txn_date
       , (data->'CustomerRef'->>'value')::INTEGER as customer_id
       , (data->'DepositToAccountRef'->>'value')::INTEGER as account_id
       , (data->>'TotalAmt')::NUMERIC as amount
       , (data->>'UnappliedAmt')::NUMERIC as unapplied_amount
       , (data->'CurrencyRef'->>'value')::fin.currency_type as currency
       , (data->>'PrivateNote') as private_note
  FROM raw
`
module.exports.line = `
  INSERT INTO fin.payment_line (
      origin, company, txn_id, line_num,
      amount, linked_type, linked_id
  )
  SELECT origin
       , company
       , txn_id
       , line_num
       , (line->>'Amount')::NUMERIC as amount
       , CASE WHEN (line->'LinkedTxn'->0->>'TxnType')
                IN ('Expense', 'Check', 'CreditCardCredit')
              THEN 'purchase'::fin.txn_type
              ELSE LOWER(line->'LinkedTxn'->0->>'TxnType')::fin.txn_type
         END linked_type
       , (line->'LinkedTxn'->0->>'TxnId')::INTEGER as linked_id
  FROM raw
  INNER JOIN jsonb_array_elements(data->'Line')
             WITH ORDINALITY AS l(line, line_num) ON TRUE
`

module.exports.rawCustomerIds = `
  SELECT origin
       , company
       , (data->'CustomerRef'->>'value')::INTEGER as customer_id
  FROM raw
`
